import React, { ReactNode, useEffect, useRef } from 'react';
import { Icon } from '../Icon';

import './styles.scss';

interface Props {
    children: ReactNode;
    visible: boolean;
    className?: string;
    containerClassName?: string;
    visibilityHandler: () => void;
    onCloseCallback?: () => void;
}

export const Modal = ({
    children,
    visible,
    className = '',
    containerClassName = '',
    visibilityHandler,
    onCloseCallback,
}: Props) => {
    const modalRef = useRef<HTMLDivElement>(null);

    const setModalHeight = () => {
        if (modalRef?.current) {
            modalRef.current.style.height = `${window.innerHeight}px`;
        }
    };

    const closeHandler = () => {
        visibilityHandler();

        if (onCloseCallback) {
            onCloseCallback();
        }
    };

    useEffect(() => {
        if (visible) {
            document.documentElement.setAttribute('DisableScroll', 'true');
            setModalHeight();
            if (window.visualViewport) {
                window.visualViewport.addEventListener('resize', setModalHeight);
            } else {
                window.addEventListener('resize', setModalHeight);
            }
        } else {
            document.documentElement.removeAttribute('DisableScroll');
            if (window.visualViewport) {
                window.visualViewport.removeEventListener('resize', setModalHeight);
            } else {
                window.removeEventListener('resize', setModalHeight);
            }
        }

        return () => {
            document.documentElement.removeAttribute('DisableScroll');
            if (window.visualViewport) {
                window.visualViewport.removeEventListener('resize', setModalHeight);
            } else {
                window.removeEventListener('resize', setModalHeight);
            }
        };
    }, [visible, modalRef, window, setModalHeight]);

    if (visible) {
        return (
            <div className='app-modal' ref={modalRef}>
                <div className='app-modal__backdrop' onClick={closeHandler}></div>
                <div className={`app-modal__relative-wrap ${containerClassName}`}>
                    <button className='app-modal__close-button' onClick={closeHandler}>
                        <Icon icon='xmark-solid' size='24' color='white' />
                    </button>
                    <div className={`app-modal__content ${className}`}>{children}</div>
                </div>
            </div>
        );
    }

    return null;
};
